import type { AppProps } from "next/app";
import Head from "next/head";
import { FunctionComponent } from "react";

import { Chat, Layout } from "@/components";

import "@ufadiz/chat-widget/style.css";

import "@/styles/chat.css";
import "@/styles/fonts.css";
import "@/styles/globals.css";

const App: FunctionComponent<AppProps> = ({ Component, pageProps }) => (
  <>
    <Head>
      <meta content="width=device-width,initial-scale=0.6" name="viewport" />
    </Head>
    <Layout>
      <Component {...pageProps} />
    </Layout>
    <Chat />
  </>
);

export default App;
